import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Link, useNavigate } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import dayjs from "dayjs";
import { all_routes } from "../router/all_routes";
import useApi from "../../core/customhook/useApi";

interface TrainingEvent {
    id: number;
    training_title: string;
    start_date: string;
    nominated: number;
}


const EmployeeTraningList = () => {

    const [trainingEvents, setTrainingEvents] = useState([])

    const { data: calenderData, error: calenderError, loading: calenderLoading } = useApi("/api/get-calender-training", {
        method: "GET",
        autoCall: true
    })
    // console.log(calenderData, "adsfasdfasdfasdfasdfasd")
    useEffect(() => {
        if (calenderData?.success && Array.isArray(calenderData.data)) {
            const mapped = calenderData.data.map((item: any) => ({
                id: item.schedule_id,
                trainingName: item.training_title,
                trainingDate: item.start_date,
                booked: item.nominated === 1,
            }));
            setTrainingEvents(mapped);
        }
    }, [calenderData]);


    // console.log(calenderData)

    const navigate = useNavigate();

    // Handle booking clicks
    const handleTrainingClick = (training: TrainingEvent) => {
        navigate("/nomination-page", { state: { training } });
    };
    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Employee Training Management</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.employeeDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Training Management</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Employee Training Management
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="ms-2 head-icons">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>

                    {/* Calendar */}
                    <div className="row">
                        <div className="col-md-12 col-xxl-12 col-xl-12 theiaStickySidebar">
                            <div className="stickybar">
                                <div className="card border-0">
                                    <div className="card-body">
                                        <FullCalendar
                                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                            initialView="dayGridMonth"
                                            headerToolbar={{
                                                start: "today",
                                                center: "title",
                                                end: "prev,next",
                                            }}
                                            height="auto"
                                            dayCellContent={({ date }) => {
                                                const formatted = dayjs(date).format("YYYY-MM-DD");
                                                const trainings = trainingEvents.filter((t: any) => t.trainingDate === formatted);

                                                return (
                                                    <div
                                                        style={{
                                                            textAlign: "center",
                                                            cursor: trainings.length > 0 ? "pointer" : "default"
                                                        }}
                                                    >
                                                        <div style={{ fontWeight: "bold" }}>{date.getDate()}</div>
                                                        {trainings.map((training: any, idx) => {
                                                            console.log("training data", training); // ✅ This is allowed

                                                            return (
                                                                <div
                                                                    key={idx}
                                                                    style={{
                                                                        marginTop: "4px",
                                                                        padding: "2px 4px",
                                                                        borderRadius: "4px",
                                                                        backgroundColor: training.booked === true ? "black" : "red",
                                                                        color: "#fff",
                                                                        fontSize: "10px",
                                                                        cursor: "pointer"
                                                                    }}
                                                                    onClick={() => handleTrainingClick(training)}
                                                                >
                                                                    {training.trainingName}
                                                                </div>
                                                            );
                                                        })}

                                                    </div>
                                                );
                                            }}

                                        />


                                        {/* Legend */}
                                        <div className="py-3">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="">
                                                            <ul className="list-unstyled mb-2 d-flex gap-5">
                                                                <li>
                                                                    <strong
                                                                        style={{
                                                                            display: "inline-block",
                                                                            width: "16px",
                                                                            height: "16px",
                                                                            backgroundColor: "red",
                                                                            marginRight: "8px",
                                                                        }}
                                                                    ></strong>
                                                                    Nominate
                                                                </li>
                                                                <li>
                                                                    <strong
                                                                        style={{
                                                                            display: "inline-block",
                                                                            width: "16px",
                                                                            height: "16px",
                                                                            backgroundColor: "black",
                                                                            marginRight: "8px",
                                                                        }}
                                                                    ></strong>
                                                                    Nominated
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Training Table */}
                                        {/* <div className="card mt-4">
                                            <div className="card-header">
                                                <h5 className="mb-0">Training Schedule</h5>
                                            </div>
                                            <div className="card-body">
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Training Name</th>
                                                            <th>Training Date</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {trainingEvents.map((ev, idx) => (
                                                            <tr key={ev.id}>
                                                                <td>{idx + 1}</td>
                                                                <td>{ev.trainingName}</td>
                                                                <td>{dayjs(ev.trainingDate).format("DD MMM YYYY")}</td>
                                                                <td>
                                                                    {ev.booked ? (
                                                                        <span style={{ color: "green", fontWeight: 600 }}>Booked</span>
                                                                    ) : (
                                                                        <span style={{ color: "red", fontWeight: 600 }}>Not Booked</span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> */}
                                        {/* /Training Table */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="footer d-flex align-items-center justify-content-center border-top bg-white p-3">
                    <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
                </div>
            </div>
            {/* /Page Wrapper */}
        </>
    );
};

export default EmployeeTraningList;

// import React, { useEffect, useState } from "react";
// import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import timeGridPlugin from "@fullcalendar/timegrid";
// import interactionPlugin from "@fullcalendar/interaction";
// import { Link } from "react-router-dom";
// import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
// import useApi from "../../../core/customhook/useApi";
// import dayjs from "dayjs";
// import Loader from "../../../core/common/selfLoder";
// import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
// import weekOfYear from "dayjs/plugin/weekOfYear";
// import { all_routes } from "../../router/all_routes";

// dayjs.extend(isSameOrBefore);
// dayjs.extend(weekOfYear);

// interface Holiday {
//     holiday: string;
//     holiday_date: string;
//     holiday_category: string;
//     location: string;
// }

// interface HolidaysMainResponse {
//     success: boolean;
//     message: string;
//     statusCode: number;
//     data: Holiday[];
// }

// const EmployeeTraningList = () => {
//     const [events, setEvents] = useState<any>([]);
//     const [holidaySet, setHolidaySet] = useState<Set<string>>(new Set());
//     const [weekendSet, setWeekendSet] = useState<Set<string>>(new Set());
//     const formatFinancialYear = (year: number) => {
//         const nextYearShort = (year + 1).toString().slice(-2);
//         return `${year}-${nextYearShort}`;
//     };

//     const getCurrentFinancialYear = () => {
//         const today = new Date();
//         const year = today.getFullYear();
//         const month = today.getMonth();
//         const fyStart = month >= 3 ? year : year - 1;
//         return formatFinancialYear(fyStart);
//     };
//     const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());



//     return (
//         <>
//             {/* Page Wrapper */}
//             <div className="page-wrapper">
//                 <div className="content">
//                     {/* Breadcrumb */}
//                     <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
//                         <div className="my-auto mb-2">
//                             <h2 className="mb-1">Employee Training Management</h2>
//                             <nav>
//                                 <ol className="breadcrumb mb-0">
//                                     <li className="breadcrumb-item">
//                                         <Link to={all_routes.employeeDashboard}>
//                                             <i className="ti ti-smart-home" />
//                                         </Link>
//                                     </li>
//                                     <li className="breadcrumb-item">Training Management</li>
//                                     {/* <li className="breadcrumb-item">OD</li> */}
//                                     {/* <li className="breadcrumb-item">
//                                         <Link to={all_routes.selfOutDutyGrid}>Self Out Duty</Link>
//                                     </li> */}
//                                     <li className="breadcrumb-item active" aria-current="page">
//                                         Employee Training Management
//                                     </li>
//                                 </ol>
//                             </nav>
//                         </div>
//                         <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
//                             <div className="ms-2 head-icons">
//                                 <CollapseHeader />
//                             </div>
//                         </div>
//                     </div>
//                     <div className="row">
//                         <div className="col-md-12 col-xxl-12 col-xl-12  theiaStickySidebar">
//                             <div className="stickybar">
//                                 <div className="card border-0">
//                                     <div className="card-body">
//                                         <FullCalendar
//                                             plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
//                                             initialView="dayGridMonth"
//                                             headerToolbar={{
//                                                 start: "today",
//                                                 center: "title",
//                                                 end: "prev,next",
//                                             }}
//                                             height="auto"
//                                         />

//                                         {/* Legend */}
//                                         <div className="py-3">
//                                             <div className="card">
//                                                 <div className="card-body">
//                                                     <div className="row">
//                                                         <div className="">
//                                                             <ul className="list-unstyled mb-2 d-flex gap-5">
//                                                                 <li>
//                                                                     <strong
//                                                                         style={{
//                                                                             display: "inline-block",
//                                                                             width: "16px",
//                                                                             height: "16px",
//                                                                             backgroundColor: "green",
//                                                                             marginRight: "8px",
//                                                                         }}
//                                                                     ></strong>
//                                                                     Nominate
//                                                                 </li>
//                                                                 <li>
//                                                                     <strong
//                                                                         style={{
//                                                                             display: "inline-block",
//                                                                             width: "16px",
//                                                                             height: "16px",
//                                                                             backgroundColor: "#FFFF00",
//                                                                             marginRight: "8px",
//                                                                             border: "1px solid #ccc",
//                                                                         }}
//                                                                     ></strong>
//                                                                     Nominated
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         {/* /Legend */}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
//                     <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
//                 </div>
//             </div>
//             {/* /Page Wrapper */}
//         </>
//     );
// };

// export default EmployeeTraningList;


// import React, { useEffect, useState } from "react";
// import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import timeGridPlugin from "@fullcalendar/timegrid";
// import interactionPlugin from "@fullcalendar/interaction";
// import { Link } from "react-router-dom";
// import { all_routes } from "../../router/all_routes";
// import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
// import useApi from "../../../core/customhook/useApi";
// import dayjs from "dayjs";
// import Loader from "../../../core/common/selfLoder";

// const EmployeeTraningList = () => {
//     const formatFinancialYear = (year: number) => {
//         const nextYearShort = (year + 1).toString().slice(-2);
//         return `${year}-${nextYearShort}`;
//     };

//     const getCurrentFinancialYear = () => {
//         const today = new Date();
//         const year = today.getFullYear();
//         const month = today.getMonth();
//         const fyStart = month >= 3 ? year : year - 1;
//         return formatFinancialYear(fyStart);
//     };

//     const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

//     // Fetch team leave calendar
//     const {
//         data: teamLeaveCalenderData,
//         loading: teamLeaveCalenderLoading,
//     } = useApi("/api/manager/view-od-team-calendar", {
//         method: "POST",
//         autoCall: true,
//         payload: { financial_year: finance_year },
//     });

//     useEffect(() => {
//         if (teamLeaveCalenderData) {
//             console.log(teamLeaveCalenderData?.data, "teamLeaveCalenderData....");
//         }
//     }, [teamLeaveCalenderData]);

//     return (
//         <>
//             <Loader loading={teamLeaveCalenderLoading} />
//             <div className="page-wrapper">
//                 <div className="content">
//                     {/* Breadcrumb */}
//                     <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
//                         <div className="my-auto mb-2">
//                             <h2 className="mb-1">Employee Training Management</h2>
//                             <nav>
//                                 <ol className="breadcrumb mb-0">
//                                     <li className="breadcrumb-item">
//                                         <Link to={all_routes.employeeDashboard}>
//                                             <i className="ti ti-smart-home" />
//                                         </Link>
//                                     </li>
//                                     <li className="breadcrumb-item">Training Management</li>
//                                     {/* <li className="breadcrumb-item">Out Duty</li> */}
//                                     {/* <li className="breadcrumb-item">
//                                         <Link to={all_routes.seflGrid}>Team Out Duty</Link>
//                                     </li> */}
//                                     <li
//                                         className="breadcrumb-item active"
//                                         aria-current="page"
//                                     >
//                                         Employee Training Management
//                                     </li>
//                                 </ol>
//                             </nav>
//                         </div>
//                         <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
//                             {/* Financial Year Selector */}
//                             <div className="input-icon w-120 position-relative mb-2">
//                                 <span className="input-icon-addon">
//                                     <i className="ti ti-calendar text-gray-9" />
//                                 </span>
//                                 <select
//                                     value={finance_year}
//                                     onChange={(e) => setFinance_year(e.target.value)}
//                                     className="form-select"
//                                 >
//                                     {(() => {
//                                         const today = new Date();
//                                         const currentYear =
//                                             today.getMonth() >= 3
//                                                 ? today.getFullYear()
//                                                 : today.getFullYear() - 1;

//                                         return [0].map(() => {
//                                             const year = currentYear;
//                                             const nextYearShort = String(year + 1).slice(-2);
//                                             const financialYear = `${year}-${nextYearShort}`;

//                                             return (
//                                                 <option key={financialYear} value={financialYear}>
//                                                     {financialYear}
//                                                 </option>
//                                             );
//                                         });
//                                     })()}
//                                 </select>
//                             </div>
//                             <div className="ms-2 head-icons">
//                                 <CollapseHeader />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Calendar */}
//                     <div className="row">
//                         <div className="col-md-12 col-xxl-12 col-xl-12 theiaStickySidebar">
//                             <div className="stickybar">
//                                 <div className="card border-0">
//                                     <div className="card-body">
//                                         <FullCalendar
//                                             plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
//                                             initialView="dayGridMonth"
//                                             headerToolbar={{
//                                                 start: "today",
//                                                 center: "title",
//                                                 end: "prev,next",
//                                             }}
//                                             height="auto"
//                                             dayCellContent={({ date }) => {
//                                                 const formatted = dayjs(date).format("YYYY-MM-DD");

//                                                 const leavesForDay =
//                                                     teamLeaveCalenderData?.data?.filter(
//                                                         (leave: any) => leave.from_date === formatted
//                                                     ) || [];

//                                                 return (
//                                                     <div
//                                                         style={{ position: "relative", textAlign: "center" }}
//                                                     >
//                                                         {/* Date */}
//                                                         <div style={{ fontWeight: "bold" }}>
//                                                             {date.getDate()}
//                                                         </div>

//                                                         {/* Employees on leave */}
//                                                         {leavesForDay.length > 0 && (
//                                                             <div
//                                                                 style={{
//                                                                     marginTop: "4px",
//                                                                     fontSize: "0.7rem",
//                                                                     lineHeight: "1rem",
//                                                                     whiteSpace: "normal",
//                                                                 }}
//                                                             >
//                                                                 {leavesForDay
//                                                                     .map((leave: any) => ({
//                                                                         ...leave,
//                                                                         leave_type_short: leave.leave_type
//                                                                     }))
//                                                                     .map((leave: any) => (
//                                                                         <div
//                                                                             key={leave.leave_application_id}
//                                                                             style={{
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600",
//                                                                                 color: "#2e3294",
//                                                                             }}
//                                                                         >
//                                                                             {leave.employee_name} - {"OD"}
//                                                                             {/* {leave.leave_type_short} */}
//                                                                         </div>
//                                                                     ))}
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 );
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 {/* Footer */}
//                 <div className="footer d-flex align-items-center justify-content-center border-top bg-white p-3">
//                     <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default EmployeeTraningList;


